/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Resource_ColInputs */

const en_admin_permissions_resource_col = /** @type {(inputs: Admin_Permissions_Resource_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource`)
};

/**
* | output |
* | --- |
* | "Resource" |
*
* @param {Admin_Permissions_Resource_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_resource_col = /** @type {((inputs?: Admin_Permissions_Resource_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Resource_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_resource_col(inputs)
});
export { admin_permissions_resource_col as "admin.permissions.resource_col" }